import { useEffect, useState } from 'react';
import { Award } from 'lucide-react';
import { round2 } from '../lib/api';

const COLORS = { 'A+': 'bg-[#1B5E20]', A: 'bg-[#2E7D32]', B: 'bg-[#E67E22]', C: 'bg-[#D35400]', D: 'bg-[#B71C1C]' };

export default function StoreScoreBadge({ storeId }) {
  const [sc, setSc] = useState(null);
  useEffect(() => { round2.storeScore(storeId).then(setSc).catch(() => {}); }, [storeId]);
  if (!sc) return null;
  return (
    <span data-testid="store-score-badge" className={`mt-2 ml-2 inline-flex items-center gap-1.5 rounded-full text-white px-3 py-1 text-xs font-bold shadow-sm ${COLORS[sc.grade] || 'bg-ink'}`}>
      <Award className="w-3.5 h-3.5"/>{sc.grade === 'New' ? 'New seller' : `Seller grade ${sc.grade} · ${sc.label}`}
    </span>
  );
}
